<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="landPrefixForm">
      <div class="">
        <h3 class="form_name">Land Prefix</h3>
  
  
          <div class="input">
            <label for="">Land Prefix Code</label>
            <input type="text" class="default_input reference-form" formControlName="LandPrefixCode" />
            <label for="">Land Prefix Name</label>
            <input type="text" class="default_input reference-form" formControlName="LandPrefixName" />
          </div>
  
  
        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null" 
            (click)="addNew(landPrefixForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null" 
            (click)="addNew(landPrefixForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>
  
        </div>
  
      </div>
    </form>
      <div class="display_table">
        <div class="search_container">
          <input type="text" class="default_input search"
          placeholder="Search for Land Prefix"
          [formControl]="control"
          [appAutocomplete]="autocomplete"
          />
          <em class="ti-search"></em> 
  
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="(landPrefixs | filterReference: control.value) as result"
              >
                <app-option
                  (click)="selectLandPrefix(option.id)"
                  *ngFor="let option of result"
                  [value]="option.LandPrefixCode"
                  [value]="option.LandPrefixName"
                >
                  {{ option. LandPrefixCode}}
                  {{ option.LandPrefixName }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
        </div>
  
        <div class="head" >
          <span class="item">S/N</span>
          <span class="item">LandPrefix Code</span>
          <span class="item">LandPrefix Name</span>
          <span class="item">Action</span>
  
        </div>
  
      <div class="scroll">
  
      </div>
      <div class="body_content" >
        <div class="the_body"
        *ngFor="let landPrefix of landPrefixFormArray.get('LandPrefixs')['controls']; index as i"
        (click)="onEdit(i, landPrefix.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{i + 1}}</span>
          <span class="content">{{landPrefix.value.LandPrefixCode}}</span>
          <span class="content">{{landPrefix.value.LandPrefixName}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"
  
            (click)="deleteLandPrefix(i, landPrefix.value)">
            <em class="ti-trash"> </em> </button>
          </span>
  
        </div>
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit(landPrefixFormArray.value)">Submit</button>
        </div>
      </div>
    </div>
  </main>
  
  <div class="box green_box"></div>
  <div class="box pink_box"></div>
  